<template>
  <div style="height: 80vh;" class="d-flex align-items-center">
    <form class="form-signin">
      <div class="text-center mb-4">
        <img class="mb-4" src="@/assets/img/logo.png" alt="Bigfox logo">
        <h3 class="mb-3 font-weight-normal">Login</h3> with your Bigfox account
      </div>

      <b-alert variant="danger" :show="loginFailed">Incorrect username or password</b-alert>

      <div class="form-label-group">
        <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus v-model="username">
        <label for="inputEmail">Email address</label>
      </div>

      <div class="form-label-group">
        <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password">
        <label for="inputPassword">Password</label>
      </div>

      <busy-btn :busy="busy" variant="primary" block size="lg" type="submit" @click.prevent="login">Login</busy-btn>

    </form>
  </div>

</template>

<script>
import isString   from 'lodash/isString';
import BusyBtn    from '@/components/BusyBtn';
import {onLogin}  from '@/vue-apollo';
import {M_LOGIN} from '@/lib/constants';

export default
{
    components: { BusyBtn },
    data()
    {
        return {
            busy: false,
            loginFailed: false,
            password: '',
            username: ''
        }
    },
    methods:
    {
        async login()
        {
            this.busy = true;
            this.loginFailed = false;

            try
            {
                await this.$apollo.mutate(
                    {
                        mutation: require('../graphql/mutation/login.gql'),
                        variables:
                        {
                            input: { password: this.password, username: this.username }
                        }
                    }
                );

                await onLogin(this.$apollo.getClient());
                this.$store.commit(M_LOGIN, {username: this.username});

                let destination = this.$route.query.redirect;

                if(!(isString(destination) && destination.length > 0))
                {
                    destination = '/main/overview/tasks';
                }
                else if(destination === '/')
                {
                    destination = '/main/overview/tasks';
                }

                await this.$router.push(destination);
            }
            catch (e)
            {
                console.error(e);
                this.loginFailed = true;
            }

            this.busy = false;
        }
    }
}
</script>

<style>
.form-signin
{
    width: 100%;
    max-width: 420px;
    padding: 15px;
    margin: auto;
}

.form-label-group {
    position: relative;
    margin-bottom: 1rem;
}

.form-label-group input,
.form-label-group label {
    height: 3.125rem;
    padding: .75rem;
}

.form-label-group label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    margin-bottom: 0; /* Override default `<label>` margin */
    line-height: 1.5;
    color: #495057;
    pointer-events: none;
    cursor: text; /* Match the input under the label */
    border: 1px solid transparent;
    border-radius: .25rem;
    transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
    color: transparent;
}

.form-label-group input::-moz-placeholder {
    color: transparent;
}

.form-label-group input:-ms-input-placeholder {
    color: transparent;
}

.form-label-group input::-ms-input-placeholder {
    color: transparent;
}

.form-label-group input::placeholder {
    color: transparent;
}

.form-label-group input:not(:-moz-placeholder-shown) {
    padding-top: 1.25rem;
    padding-bottom: .25rem;
}

.form-label-group input:not(:-ms-input-placeholder) {
    padding-top: 1.25rem;
    padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) {
    padding-top: 1.25rem;
    padding-bottom: .25rem;
}

.form-label-group input:not(:-moz-placeholder-shown) ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #777;
}

.form-label-group input:not(:-ms-input-placeholder) ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #777;
}

.form-label-group input:not(:placeholder-shown) ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #777;
}

.form-label-group input:-webkit-autofill ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #777;
}

/* Fallback for Edge
-------------------------------------------------- */
@supports (-ms-ime-align: auto) {
    .form-label-group {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column-reverse;
        flex-direction: column-reverse;
    }

    .form-label-group label {
        position: static;
    }

    .form-label-group input::-ms-input-placeholder {
        color: #777;
    }
}
</style>